import angular from "angular";

angular
	.module('app')
	.component('dfApplicationsReportPage', {
		template: require('./df-applications-report-page.html'),
        controller: ['$http', 'moment', controller],
        bindings: {
            //
        }
    });

function controller($http, moment) {

	let $ctrl = this;

    $ctrl.startDate = null;
    $ctrl.endDate = null;
    $ctrl.cars = null;
    $ctrl.total = 0;

	$ctrl.$onInit = function () {
    };

	$ctrl.getList = () => {
	    $ctrl.loading = true;
	    const url = '/df/reports/get-list';
	    const params = {
	        start_date: moment($ctrl.startDate).format('YYYY-MM-DD'),
            end_date: $ctrl.endDate ? moment($ctrl.endDate).format('YYYY-MM-DD') : null,
        }
	    $http.post(url, params).then((res) => {
	        $ctrl.loading = false;
	        $ctrl.cars = res.data;
	        $ctrl.total = Object.keys($ctrl.cars).length;
        }, (error) => {
	        $ctrl.loading = false;
            let checked = false;
            let message = '';
            angular.forEach(error.data.errors, function (value, key){
                if (!checked) {
                    message += value[0];
                    checked = true;
                }
            });
            if (message.length) {
                window.Swal.fire({
                    icon: 'error',
                    title: message,
                })
            } else {
                alert("Не известная ошибка обратитесь к администраций сайта");
            }
        });
    }
}
